import React from 'react'
import PropTypes from 'prop-types'

// Styles
import './FileHelp.scss'

const FileHelp = ({ title, items }) => {
  return (
    <div className="x-file-help">
      <div className="title">{title}</div>
      <div className="items">
        {items.map((item, index) => {
          return <p key={index}>{item}</p>
        })}
      </div>
    </div>
  )
}

FileHelp.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  items: PropTypes.arrayOf(PropTypes.string),
}

FileHelp.defaultProps = {
  title: 'Upload file user will download',
  items: [
    '- File must be less than 3MB',
    '- File type must be .pdf , .doc, .docx or .mp4',
  ],
}

export default FileHelp
